/**
 * Times on screen, in the shop's zone and saying so.
 *
 * Timestamps arrive as UTC instants. `toLocaleString` would show them in
 * whatever zone the viewer's machine is set to, which for a planner on the
 * road, or a laptop left on UTC, is not the clock the shop runs on, and gives
 * no hint that it isn't. Every timestamp the screens show goes through here,
 * in Central, labeled CT, so "Applied 7:05 PM CT" means the same thing to
 * everyone and agrees with the server's idea of which day it is.
 *
 * The zone is the same constant the server defaults to rather than one the
 * server reports: the label is "CT", and a zone other than Central would need
 * a different label as well as a different clock.
 */
import { DEFAULT_TIME_ZONE, localDay } from "../domain/time.js";

export const SHOP_TIME_ZONE = DEFAULT_TIME_ZONE;

const DATE_TIME = new Intl.DateTimeFormat("en-US", {
  timeZone: SHOP_TIME_ZONE,
  year: "numeric", month: "short", day: "numeric",
  hour: "numeric", minute: "2-digit",
});

/** "Sep 24, 2026, 7:05 PM CT". Anything unparseable is shown as it came. */
export function formatCT(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${DATE_TIME.format(d)} CT`;
}

/** The shop's calendar day an instant falls on, as YYYY-MM-DD. */
export function dayCT(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return localDay(d, SHOP_TIME_ZONE);
}
